// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import {
    LoadRealTimePrices as baseLoadRealTimePrices,
    chain,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import { getKitConfigurationOptionIds } from "@store/Framework/Utilities/KitProductInfoUtilities";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadRealTimePrices = createChainHandler("LoadRealTimePrices", chain, async props => {
    const { wishListLineCollection } = props.apiResult;
    if (!wishListLineCollection?.length) {
        props.pricingLoaded = true;
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: wishListLineCollection.map(o => ({
                productId: o.productId,
                unitOfMeasure: o.unitOfMeasure,
                qtyOrdered: o.qtyOrdered,
                configuration: getKitConfigurationOptionIds(o), // Store Custom Code
            })),
            onComplete: realTimePricingProps => {
                if (realTimePricingProps?.apiResult?.realTimePricingResults) {
                    realTimePricingProps.apiResult.realTimePricingResults.forEach(pricing => {
                        for (let i = 0; i < wishListLineCollection.length; i++) {
                            const wishListLine = wishListLineCollection[i];
                            if (
                                wishListLine.productId === pricing.productId &&
                                wishListLine.unitOfMeasure === pricing.unitOfMeasure
                            ) {
                                wishListLine.pricing = pricing;
                            }
                        }
                    });
                }

                props.pricingLoaded = true;
            },
        }),
    );

    await waitFor(() => !!props.pricingLoaded);
});

replaceInChain(chain, baseLoadRealTimePrices, LoadRealTimePrices);
